import type { IconData } from '@stacksjs/iconify-core'

export const arrowBottom: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m367.997 338.75l-95.998 95.997V17.503h-32v417.242l-95.996-95.995l-22.627 22.627L256 496l134.624-134.623z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default arrowBottom
